import "./signup.css";
import { COURSE_PRICE_LABEL } from "../../utils/coursePricing";
import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  getStates,
  userLogin,
  userSignupWithShortDet,
  VerifyUser,
} from "../../api/server";
import { login, signup } from "../../store/userSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import updateInstance from "../../api/server";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import AttorneyInfoModal from "./AttorneyInfoModal";
import SetupBirthDatePicker from "./SetupBirthDatePicker";
import Header from "../../layouts/header";
import { FiFileText, FiInfo } from "react-icons/fi";
import "./signupFeeHelp.css";
import { WEBSITE_URL } from "../../config/externalUrls";
const modalStyles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    zIndex: 9999,
  },

  modal: {
    background: "#fff",
    borderRadius: "14px",
    maxWidth: "800px",
    width: "100%",
    maxHeight: "82vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    border: "1px solid #c8e6c0",
  },

  header: {
    background: "linear-gradient(135deg, #2e7d32 0%, #4CAF50 100%)",
    padding: "22px 28px 18px",
    flexShrink: 0,
  },

  headerTop: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "6px",
  },

  headerIcon: {
    width: "40px",
    height: "40px",
    background: "rgba(255,255,255,0.2)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  headerTitle: {
    color: "#fff",
    fontSize: "19px",
    fontWeight: 700,
    margin: 0,
  },

  headerText: {
    color: "rgba(255,255,255,0.82)",
    fontSize: "13px",
    paddingLeft: "52px",
    margin: 0,
  },

  body: {
    overflowY: "auto",
    padding: "22px 28px",
    flex: 1,
    background: "#fff",
  },

  section: {
    marginBottom: "18px",
  },

  sectionTitleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    marginBottom: "8px",
  },

  sectionTitle: {
    fontSize: "11px",
    fontWeight: 700,
    color: "#2e7d32",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    whiteSpace: "nowrap",
    margin: 0,
  },

  sectionLine: {
    flex: 1,
    height: "1px",
    background: "#e8f5e9",
  },

  paragraph: {
    fontSize: "13px",
    lineHeight: 1.75,
    color: "#333",
    marginBottom: "8px",
  },

  contactBox: {
    background: "#f1f8e9",
    border: "1px solid #c8e6c0",
    borderLeft: "4px solid #4CAF50",
    borderRadius: "8px",
    padding: "14px 16px",
    fontSize: "13px",
    color: "#444",
    lineHeight: 1.9,
    marginTop: "6px",
  },

  footer: {
    padding: "16px 28px 18px",
    borderTop: "1px solid #e8f5e9",
    background: "#f9fdf9",
    flexShrink: 0,
  },

  checkboxRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginBottom: "16px",
    background: "#e8f5e9",
    borderRadius: "8px",
    padding: "12px 14px",
  },

  checkbox: {
    marginTop: "2px",
    accentColor: "#2e7d32",
    width: "17px",
    height: "17px",
    flexShrink: 0,
    cursor: "pointer",
  },

  checkboxLabel: {
    fontSize: "13px",
    color: "#2e7d32",
    fontWeight: 500,
    lineHeight: 1.5,
    cursor: "pointer",
  },

  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },

  cancelBtn: {
    background: "#fff",
    border: "1.5px solid #ccc",
    borderRadius: "50px",
    padding: "9px 22px",
    fontSize: "14px",
    color: "#666",
    cursor: "pointer",
    fontWeight: 500,
  },

  agreeBtn: (enabled) => ({
    background: enabled ? "#4CAF50" : "#a5d6a7",
    border: "none",
    borderRadius: "50px",
    padding: "9px 24px",
    fontSize: "14px",
    color: "#fff",
    cursor: enabled ? "pointer" : "not-allowed",
    fontWeight: 700,
  }),
};
const disclosureSections = [
  {
    title: "Who is Evergreen?",
    content: [
      `We are a non-profit credit counseling and educational provider approved by the U.S.
Trustees and Bankruptcy Administrators to offer pre-bankruptcy credit counseling and
post-bankruptcy personal financial management in compliance with the Bankruptcy
Code. The educational and training background of all our counselors either meets or
exceeds standards of the U.S. Trustees and Bankruptcy Administrators. Our counselors
have completed training and certification in credit counseling and personal financial
management. We are funded exclusively on the nominal fee for service charged to
students and we do not pay or receive fees or other considerations for referrals, nor do
our courses contain any commercial advertising. We do not promote, market, or sell any
financial products, or solicit business of any type. We do not offer alternative payment
schedules regarding unsecured debt, such as debt repayment plans. Participation in our
courses will not impact a student's credit report in any way.`,
    ]
  },

  {
    title: "Credit Counseling",
    content: [
      `Our pre-bankruptcy credit counseling session consists of a confidential financial
interview, an in-depth financial analysis, as well as a presentation of your available
options. We also discuss common causes that lead people to financial hardships. You
will need to have a follow-up conversation with a counselor via email or telephone. After
completion of this course, Evergreen Financial Counseling will provide a certificate of
completion to you and your attorney (if applicable) within one business day. Evergreen
is obligated to provide your certificate after the completion of your course in a prompt
manner. You will need to complete the entire course in order to receive a certificate of
completion. If you chose to pay by check or money order, the delivery of your certificate
will be held until payment is received. If you require immediate delivery of your
certificate of completion, please contact Evergreen via email or telephone.`
    ]
  },

  {
    title: "Debtor Education",
    content: [
      `Our post-bankruptcy debtor education (personal financial management) course
discusses the psychology of spending, how to make and keep financial goals, writing
down a budget, debt warning signs, good vs. bad credit, financial safety nets, and
consumer protection laws. After completion of this course, Evergreen Financial
Counseling will provide a certificate of completion to you and your attorney (if
applicable) within one business day. Evergreen is obligated to provide your certificate
after the completion of your course in a prompt manner. You will need to complete the
entire course in order to receive a certificate of completion. If you chose to pay by check
or money order, the delivery of your certificate will be held until payment is received. If
you require immediate delivery of your certificate of completion, please contact
Evergreen via email or telephone.`
    ]
  },

  {
    title: "Certificate of Completion: Validity and Filing",
    content: [
      `Your pre-bankruptcy credit counseling certificate is valid for 180 days from the date you
complete your counseling session. If you do not file your bankruptcy petition within this
period, you may be required to complete pre-filing credit counseling again before you
can file. Please provide a copy of your certificate to your attorney, if you have one, when
you meet.
Evergreen delivers your certificate of completion to you and your attorney (if applicable),
but delivery of a certificate is not the same as filing it with the court. The completed
certificate must be filed with the appropriate bankruptcy court by you or your attorney.
Evergreen will make reasonable efforts to forward certificates to your attorney where
authorized, but Evergreen is not responsible for case dismissal or delay resulting from a
certificate that is not filed with the court on time. Please confirm that you or your
attorney has received your certificate, and contact Evergreen immediately if it is
missing.`
    ]
  },

  {
    title: "Limited English and Spanish Individuals",
    content: [
      `At this time, Evergreen Financial Counseling’s sessions and courses are only provided
in the English and Spanish languages. Individuals who are not proficient in either
language will be referred to the US Trustees and Bankruptcy Administrators’ list of
approved providers that offer services in additional languages.`
    ]
  },

  {
    title: "Payment",
    content: [
      `Our Credit Counseling and Debtor Education courses cost $${COURSE_PRICE_LABEL} for single/joint filers.
We do not charge any additional fees for the generation of certificates of completion.
We accept online or over the telephone debit and credit. We run promotional discounts
in the form of coupon codes, so some of our students may pay less than $${COURSE_PRICE_LABEL}. In
addition, some of our students pre-pay with their attorneys as well. Ask your attorney if
they are set up for this service.
A fee waiver or fee reduction may be available to individuals who meet certain
household income thresholds. See "Fee Discount" for details. You do not have to pay
the full fee if you cannot afford it`
    ]
  },

  {
    title: "Fee Discount",
    content: [
      `Evergreen Financial Counseling provides its services for $${COURSE_PRICE_LABEL} per household.
However, we are committed to providing our course without regard to an individual's
ability to pay.
Individuals demonstrate need for a fee waiver in part if their household current income
is less than 150 percent and above 100 percent of the poverty guidelines updated
periodically in the Federal Register by the U.S. Department of Health and Human
Services under the authority of 42 U.S.C. 9902(2), as adjusted from time to time.
Individuals demonstrate need for a fee waiver in full if their household current income is
less than 150 percent of the poverty guidelines updated periodically in the Federal
Register by the U.S. Department of Health and Human Services under the authority of
42 U.S.C. 9902(2), as adjusted from time to time. Full fee waivers may be rebutted, and
Evergreen may offer a reduced fee instead, if Evergreen
determines based on income information the client submits in connection with
counseling services, that the client is able to pay the fee in a reduced amount, as
pursuant to 28 C.F.R. §§ 58.21 (b)(1)(ii). Notification: At the conclusion of their course,
Evergreen Financial Counseling will inform individual that they may qualify for a fee
waiver in part or whole. In order to fully verify individual’s financial situation, Evergreen
Financial Counseling will request a copy of individual’s most recent paystubs or W2s, as
well as a copy of their most recent tax return.`
    ]
  },

  {
    title: "Refund Policy",
    content: [
     `If you have paid for a course but have not completed it, you may request a refund of
your fee. Refunds are not available once a course has been completed and a certificate
of completion has been issued. For payments made by an attorney on a client's behalf,
Evergreen may issue a credit in place of a refund.
To request a refund, contact Evergreen at counselor@evergreenclass.com or 800-581-
3513. Your request will be processed once it is received and acknowledged by
authorized Evergreen personnel.`
    ]
  },

  {
    title: "You're Safe with Evergreen",
    content: [
     `Evergreen Financial Counseling uses extensive and sophisticated secure technology to
protect your data and transmissions between you and Evergreen and Agencies
participating in this website. Transmission between browsers and our web server is
implemented using Secure Sockets Layer (SSL) technology. This technology requires
an SSL-capable browser. Although Evergreen has taken these measures to ensure that
your personal information is delivered and disclosed only in accordance with your
instructions, Evergreen cannot and does not guarantee that the personal information
you provide will not be intercepted by others and decrypted.`
    ]
  },

  {
    title: "Our Privacy Policy",
    content: [
      `There are areas on our website where you’ll be asked to enter both personal and non-
personal information. We DO NOT sell or share any personal information about you to
or with any person or organization except as authorized by you, to participating
Agencies, as set forth herein, or as may be required by law or court order. We use the
information you provide to supply the US Trustees and Bankruptcy Administrators with
the appropriate information needed to confirm you’ve completed your required
counseling and/or education course. We might disclose debtor information to the United
States Trustees and Bankruptcy Administrators in connection with the United States
Trustees and Bankruptcy Administrators’ oversight of Evergreen, or during the
investigation of complaints, during on-site visits, or during quality of service reviews. In
addition, Evergreen Financial Counseling may disclose account or other personal
information when we have reason to believe that disclosing this information is
necessary to identify, contact or bring legal action against someone who may be
causing injury to or interference with Evergreen Financial Counseling's rights or
property, other website users or anyone else that could be harmed by such activities.
You can review and change your personal information in an active account at any time.
Just contact us at info@evergreenclass.com for any such requests. Federal and state
regulations may require that we store completed submissions for various periods of
time. In order to comply with these regulations, we may be unable to delete information
from our databases.
If we make a change to our Privacy Policy in the future that will affect how we treat your
information, we will notify you by e-mail of the change to the extent such change is
material. Otherwise, we will post such change at the website, and such change will be
deemed to be effective 10 days from the date of such posting. In that instance, your
ability to opt out of the new policy will be determined by applicable laws.`
    ]
  },

  {
    title: "Scope of Government Review",
    content: [
      `Approval does not endorse or assure the quality of a provider's services. The U.S.
Trustees and Bankruptcy Administrators have reviewed Evergreen's credit counseling
and Personal Financial Management courses pursuant to 11 U.S.C. § 111, but have
neither reviewed nor approved any other services offered by Evergreen.
By using any such services, you are acknowledging that you have read and understand
this policy and that you agree to be bound by its terms. If you do not agree to be bound
by the terms of this privacy policy, simply exit this page without accessing or using our
web site or any of our services.`
    ]
  }
];
const Login = () => {
  const token = localStorage.getItem("token");
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const AttorneyCode = queryParams.get("code");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);
  const [loginPassword, setLoginPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [postLoading, setPostLoading] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [statesData, setStatesData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [noCode, setNoCode] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [atternyName, setAtternyName] = useState("");
  const [atternyEmail, setAtternyEmail] = useState("");
  const [atternyNumber, setAtternyNumber] = useState("");
  const [attCodeValidation, setattCodeValidation] = useState(false);
  const [userAttorney, setUserAttorney] = useState(
    AttorneyCode ? AttorneyCode : ""
  );
  const [loading, setLoading] = useState(false);
  const [attorneyInfo, setAttorneyInfo] = useState();
  const [attorneyCodeVerified, setAttorneyCodeVerified] = useState(false);
  const [showDisclosure, setShowDisclosure] = useState(false);
  const [disclosureAccepted, setDisclosureAccepted] = useState(false);

  function valuesSetter(data) {
    setAtternyEmail(data.email);
    setAtternyName(data?.firstname);
    setAtternyNumber(data?.phone);
  }

  const handleVerifyAttorney = async (e) => {
    setattCodeValidation(false);
    // e.preventDefault();
    const body = {
      code: userAttorney,
    };
    try {
      setLoading(true);
      const response = await VerifyUser(body);
      if (response.status === 200) {
        setReadOnly(true);
        const data = response.data;
        valuesSetter(response?.data?.data);
        const attdata = {
          attorneyCode: {
            atty_name: response?.data?.data?.firstname,

            atty_email: response?.data?.data?.email,
            code: userAttorney,
          },
          data: {
            phone: response?.data?.data?.phone,
          },
        };
        setAttorneyInfo(attdata);
        setAttorneyCodeVerified(true);
        toast.success("Attorney information verified successfully!");

        setLoading(false);
      } else {
        setattCodeValidation(true);
      }
    } catch (error) {
      setattCodeValidation(true);
      setLoading(false);
    }
  };
  const checkSignup = () => {
    if (signupLoading) {
      return true;
    }
    if (userAttorney == "") {
      return false;
    }
    if (userAttorney && attorneyCodeVerified) {
      return false;
    }
    if (userAttorney && !attorneyCodeVerified) {
      return true;
    }
  };

  useEffect(() => {
    if (AttorneyCode) {
      handleVerifyAttorney();
    }
  }, []);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      dispatch(login(storedUser));
    }
  }, [dispatch]);

  useEffect(() => {
    const fetchStatesData = async () => {
      try {
        const response = await getStates();
        console.log("responseresponseresponse", response);
        setStatesData(response.data);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStatesData();
  }, []);

  const loginFormik = useFormik({
    initialValues: { username: "", password: "" },
    validationSchema: Yup.object({
      username: Yup.string().required("User Name is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      setPostLoading(true);
      userLogin(values)
        .then((res) => {
          setPostLoading(false);
          if (res.status === 200) {
            updateInstance(res.data.token);
            dispatch(login(res.data));
            localStorage.setItem("isJoint", res.data.isJoint);

            if (res.data.data.type === "Admin") {
              localStorage.setItem("adminCode", values.password);
              navigate("/admin-dashboard");
            } else if (res.data.data.type === "Atty") {
              navigate("/manage-clients");
            } else {
              navigate("/dashboard");
            }
          }
        })
        .catch((err) => {
          setPostLoading(false);
          toast.error(
            err.response?.data?.error || "An unexpected error occurred."
          );
        });
    },
  });

  useEffect(() => {
    if (token) {
      if (user?.user?.data?.type === "Admin") {
        navigate("/admin-dashboard");
      } else if (user?.user?.data?.type === "Atty") {
        navigate("/manage-clients");
      } else {
        navigate("/dashboard");
      }
    }
  }, [token, user, navigate]);

  const handleRedirection = () => {
    if (!token) {
      window.location.href = WEBSITE_URL;
    }
  };

  return (
    <div className="signup-page">
      <Header showlanguage={true} />
      <section className="login_wrap">
        <div className="login_form py-4">
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ width: "100%" }}
          >
            <div className="login_logo">
              <a href={`${WEBSITE_URL}?login=false`}>
                <img src={logo} alt="logo" />
              </a>
              {/* <p className="f18">Please enter your username/email and password</p> */}
            </div>
            <h1
              style={{ fontSize: "40px", color: "green" }}
              className="signup-heading-resposive"
            >
              Not a member yet?
            </h1>
            <h2 className="f18 mb-5" style={{ color: "green" }}>
              Join us today by signing up!
            </h2>

            <Formik
              initialValues={{
                email: "",
                state: "",
                attycode: "",
                password: "",
                confirm_password: "",
                phone: "",
                lastName: "",
                middleInitial: "",
                firstName: "",
                dob: "",
              }}
              validationSchema={Yup.object({
                email: Yup.string()
                  .email("Invalid email address")
                  .required("Email is required"),
                state: Yup.string().required("Filing State is required"),
                password: Yup.string()
                  .min(6, "Password must be at least 6 characters")
                  .max(16, "Password cannot exceed 16 characters")
                  .required("Password is required"),
                confirm_password: Yup.string()
                  .oneOf([Yup.ref("password"), null], "Passwords must match")
                  .required("Confirm Password is required"),
                phone: Yup.string().required("Phone Number is required"),
                dob: Yup.string().required("Date of Birth is required"),
                lastName: Yup.string().required("Last Name is required"),
                middleInitial: Yup.string(),
                firstName: Yup.string().required("First Name is required"),
              })}
              onSubmit={(values, { resetForm }) => {
                setSignupLoading(true);
                if (attorneyInfo) {
                  values = {
                    ...values,
                    attycode: attorneyInfo?.attorneyCode?.code,
                    attypref: "checked",
                    attyemail: attorneyInfo?.attorneyCode?.atty_email,
                    attyphone: attorneyInfo?.data?.phone,
                    attorneyname: attorneyInfo?.attorneyCode?.atty_name,
                  };
                }
                console.log("values<>>>>>>>", values);
                userSignupWithShortDet(values)
                  .then((res) => {
                    setSignupLoading(false);
                    if (res.data.message === "Success!") {
                      localStorage.setItem("authToken", res.data.token);
                      const authToken = res.data.token;
                      updateInstance(res.data.token);

                      localStorage.setItem("authToken", authToken);
                      dispatch(signup(res.data));

                      toast.success("Signup successful!");
                      resetForm();
                      navigate("/dashboard");
                    }
                  })
                  .catch((error) => {
                    setSignupLoading(false);
                    toast.error(
                      error?.response?.data?.error || "Signup failed."
                    );
                  });
              }}
            >
              {({ 
                handleSubmit,
                setFieldValue,
                submitForm,
                validateForm,
                setTouched,
               }) => (
                <>
                  <AttorneyInfoModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    setFieldValue={setFieldValue}
                    setUserAttorney={setUserAttorney}
                    setAttorneyInfo={setAttorneyInfo}
                    setAttorneyCodeVerified={setAttorneyCodeVerified}
                    attorneyInfo={attorneyInfo}
                  />
                  <Form
                    onSubmit={handleSubmit}
                    className="form-container signup-form-container"
                    style={{ width: "70%" }}
                    autoComplete="off"
                  >
                    <div className="signup-field-row">
                      <div className="input_wrap" style={{ width: "50%" }}>
                        <label className="label-title">Email</label>
                        <Field
                          type="email"
                          className="form-control"
                          name="email"
                          placeholder="Email"
                          style={{ height: "55px" }}
                          autoComplete="off"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="error-message text-danger"
                          style={{ fontSize: "14px", position: "absolute" }}
                        />
                      </div>

                      <div className="input_wrap" style={{ width: "50%" }}>
                        <label className="label-title">Filing State</label>
                        <Field
                          as="select"
                          name="state"
                          className="form-control"
                          style={{ height: "55px" }}
                        >
                          <option value="">Select a State</option>
                          {statesData.length > 0
                            ? statesData.map((state, index) => (
                                <option key={index} value={state.state}>
                                  {state.state}
                                </option>
                              ))
                            : null}
                        </Field>
                        <ErrorMessage
                          name="state"
                          component="div"
                          className="error-message text-danger"
                          style={{ fontSize: "14px", position: "absolute" }}
                        />
                      </div>
                    </div>

                    <div className="signup-field-row">
                      <div
                        className="input_wrap"
                        style={{
                          width: "50%",
                          marginBottom: "50px",
                          position: "relative",
                        }}
                      >
                        <label className="label-title">Password</label>
<div className="signup-password-control">
<Field
                          // type="password"
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          name="password"
                          placeholder="Password"
                          style={{ height: "55px" }}
                        />
<button type="button" className="signup-password-toggle" aria-label={showPassword ? "Hide password" : "Show password"} aria-pressed={showPassword} onClick={() => setShowPassword((shown) => !shown)}><i className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true" /></button>
</div>
<ErrorMessage
                          name="password"
                          component="div"
                          className="error-message text-danger"
                          style={{ fontSize: "14px", position: "absolute" }}
                        />
                      </div>

                      <div
                        className="input_wrap"
                        style={{
                          width: "50%",
                          marginBottom: "50px",
                          position: "relative",
                        }}
                      >
                        <label className="label-title">Confirm Password</label>
<div className="signup-password-control">
<Field
                          // type="password"
                          type={confirmShowPassword ? "text" : "password"}
                          className="form-control"
                          name="confirm_password"
                          placeholder="Confirm Password"
                          style={{ height: "55px" }}
                        />
<button type="button" className="signup-password-toggle" aria-label={confirmShowPassword ? "Hide confirm password" : "Show confirm password"} aria-pressed={confirmShowPassword} onClick={() => setConfirmShowPassword((shown) => !shown)}><i className={confirmShowPassword ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true" /></button>
</div>
<ErrorMessage
                          name="confirm_password"
                          component="div"
                          className="error-message text-danger"
                          style={{ fontSize: "14px", position: "absolute" }}
                        />
                      </div>
                    </div>
                    <div className="signup-field-row">
                      <div className="col-lg-6 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title">First Name</label>
                          <Field
                            type="text"
                            name="firstName"
                            className="form-control"
                            placeholder="First name"
                          />
                          <ErrorMessage
                            name="firstName"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title">Middle Initial</label>
                          <Field
                            type="text"
                            name="middleInitial"
                            className="form-control"
                            placeholder="Middle name"
                          />
                          <ErrorMessage
                            name="middleInitial"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="signup-field-row">
                      <div className="col-lg-6 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title">Last Name</label>
                          <Field
                            type="text"
                            name="lastName"
                            className="form-control"
                            placeholder="Last name"
                          />
                          <ErrorMessage
                            name="lastName"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title">Phone Number</label>
                          <Field
                            type="text"
                            className="form-control"
                            name="phone"
                            placeholder="Phone no."
                          />
                          <ErrorMessage
                            name="phone"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title" htmlFor="signup-dob">Date of Birth</label>
                        <Field name="dob">
                          {({ field, form }) => (
                            <SetupBirthDatePicker
                              allowTyping
                              id="signup-dob"
                              drop="up"
                              align="end"
                              dateFormat="yyyy-mm-dd"
                              className="client-date-picker"
                              menuClassName="client-date-picker-menu"
                              value={field.value}
                              onChange={(value) => form.setFieldValue(field.name, value)}
                              onBlur={field.onBlur}
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="dob"
                          component="div"
                          className="error-message text-danger"
                        />
                      </div>
                    </div>

                    <div className="row attorney-info-section-resposive signup-attorney-code-row">
                      {!noCode && (
                        <label className="label-title" htmlFor="signup-attorney-code">
                          Enter Attorney Code
                        </label>
                      )}
                      {!noCode && (
                        <div className="col-lg-7 col-md-7 verify-code-container-field">
                          <div
                            className="input_wrap"
                            style={{ marginBottom: "15px" }}
                          >
                            <Field
                              id="signup-attorney-code"
                              type="text"
                              className="form-control"
                              value={userAttorney}
                              onChange={(e) => {
                                setUserAttorney(e?.target?.value);
                                setattCodeValidation(false);
                              }}
                              name="attycode"
                              placeholder="Attorney code"
                              style={{ height: "55px" }}
                              readOnly={attorneyCodeVerified}
                            />
                            {attCodeValidation && (
                              <p className="text-danger">
                                Invalid Attorney Code{" "}
                              </p>
                            )}
                          </div>
                        </div>
                      )}

                      <div
                        className="col-lg-5 col-md-5 verify-code-container-button"
                      >
                        {!noCode && (
                          <button
                            className="btn_brnd-outline mr-22"
                            // disabled={postLoading}
                            type="button"
                            onClick={handleVerifyAttorney}
                            disabled={attorneyCodeVerified}
                          >
                            {loading ? (
                              <ThreeDots
                                height="20"
                                width="38"
                                radius="9"
                                color="#ed1717"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{
                                  display: "block",
                                }}
                                wrapperClassName="spinner"
                                visible={true}
                              />
                            ) : (
                              <>
                                {attorneyCodeVerified ? "Verified" : "Verify"}
                              </>
                            )}
                          </button>
                        )}
                        {/* <button
                        className="btn_brnd my-3"
                        type="button"
                        onClick={() => {
                          setNoCode(!noCode);
                          setReadOnly(false);
                          setUserAttorney("");
                          setAtternyName("");
                          setAtternyEmail("");
                          setAtternyNumber("");
                        }}
                      >
                        {noCode ? "Add Code" : " No Code ?"}
                      </button> */}
                      </div>
                    </div>
                    <p
                      style={{ fontSize: "14px" }}
                      className="attorney-info-section-text"
                    >
                      If you don’t have an attorney, leave this field blank. If
                      you're unsure whether you have an attorney code,
                      <span
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          margin: "0 5px",
                        }}
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#AttorneyInfoModal"
                      >
                        {" "}
                        click here{" "}
                      </span>
                      and we will assist you in verifying it.
                    </p>

                    <aside className="signup-fee-help" aria-labelledby="signup-fee-help-title">
                      <span className="signup-fee-help__icon" aria-hidden="true">
                        <FiInfo />
                      </span>
                      <div>
                        <h3 id="signup-fee-help-title">Need help with the course fee?</h3>
                        <p>
                          You may qualify to take the course free or at a reduced rate based on your ability to pay.{" "}
                          <a href="https://www.evergreenclass.com/fee-waiver-policy/" target="_blank" rel="noopener noreferrer">
                            View our Fee Waiver Policy
                          </a>
                        </p>
                      </div>
                    </aside>

                    {/* <button
                      type="button"
                      className="signup-link mt-2 me-3 d-flex "
                      style={{ fontSize: "18px", justifySelf: "center" }}
                      disabled={checkSignup()}
                      onClick={() => setShowDisclosure(true)}
                    >
                      {signupLoading ? (
                        <ThreeDots
                          height="20"
                          width="60"
                          radius="9"
                          color="#4fa94d"
                        />
                      ) : (
                        "Sign up"
                      )}
                    </button> */}
                    <button
                      type="button"
                      className="signup-link mt-2 me-3 d-flex"
                      style={{ fontSize: "18px", justifySelf: "center" }}
                      disabled={checkSignup()}
                      onClick={async () => {
                        const errors = await validateForm();

                        // Mark all fields as touched so errors become visible
                        setTouched({
                          email: true,
                          state: true,
                          password: true,
                          confirm_password: true,
                          phone: true,
                          firstName: true,
                          lastName: true,
                          middleInitial: true,
                          dob: true,
                        });

                        if (Object.keys(errors).length === 0) {
                          setShowDisclosure(true);
                        }
                      }}
                    >
                      {signupLoading ? (
                        <ThreeDots
                          height="20"
                          width="60"
                          radius="9"
                          color="#4fa94d"
                        />
                      ) : (
                        "Sign up"
                      )}
                    </button>


                    {showDisclosure && (
                      <div style={modalStyles.backdrop}>
                        <div style={modalStyles.modal}>
                          {/* Header */}
                          <div style={modalStyles.header}>
                            <div style={modalStyles.headerTop}>
                              <div style={modalStyles.headerIcon}>
                                <FiFileText size={22} color="#fff" />
                              </div>

                              <h2 style={modalStyles.headerTitle}>
                                Evergreen Financial Counseling — Disclosure
                              </h2>
                            </div>

                            <p style={modalStyles.headerText}>
                              Please read the following disclosure carefully before proceeding.
                            </p>
                          </div>

                          {/* Body */}
                          <div style={modalStyles.body}>
                            {disclosureSections.map((section, i) => (
                              <div key={i} style={modalStyles.section}>
                                <div style={modalStyles.sectionTitleWrapper}>
                                  <h3 style={modalStyles.sectionTitle}>{section.title}</h3>
                                  <div style={modalStyles.sectionLine} />
                                </div>

                                {section.content.map((para, j) => (
                                  <p key={j} style={modalStyles.paragraph}>
                                    {para}
                                  </p>
                                ))}
                              </div>
                            ))}

                            <div style={modalStyles.contactBox}>
                              <strong
                                style={{
                                  color: "#2e7d32",
                                  display: "block",
                                  marginBottom: "2px",
                                  fontSize: "14px",
                                }}
                              >
                                Evergreen Financial Counseling
                              </strong>

                              {/* 1300 Summit Avenue, #520 · Fort Worth, TX 76102-4419 */}
                              1751 River Run, Suite 200, Fort Worth,
                              <br />
                              TX 76107
                              <br />
                              counselor@evergreenclass.com · 800-581-3513
                            </div>
                          </div>

                          {/* Footer */}
                          <div style={modalStyles.footer}>
                            <div style={modalStyles.checkboxRow}>
                              <input
                                type="checkbox"
                                checked={disclosureAccepted}
                                onChange={(e) =>
                                  setDisclosureAccepted(e.target.checked)
                                }
                                style={modalStyles.checkbox}
                              />

                              <label style={modalStyles.checkboxLabel}>
                                I have read and agree to the Evergreen Financial Counseling
                                disclosure and privacy policy.
                              </label>
                            </div>

                            <div style={modalStyles.buttonRow}>
                              <button
                                type="button"
                                onClick={() => {
                                  setShowDisclosure(false);
                                  setDisclosureAccepted(false);
                                }}
                                style={modalStyles.cancelBtn}
                              >
                                Cancel
                              </button>

                              <button
                                type="button"
                                disabled={!disclosureAccepted}
                                onClick={async () => {
                                  setShowDisclosure(false);
                                  await submitForm();
                                  setDisclosureAccepted(false);
                                }}
                                style={modalStyles.agreeBtn(disclosureAccepted)}
                              >
                                ✓ I Agree &amp; Continue
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Form>
                </>
              )}
            </Formik>
          </div>
        </div>

        <div className="info_login_content">
          <div className="content_login_form">
            <div className="login_logo">
              <h1
                style={{
                  fontSize: "34px",
                  color: "white",
                  padding: "0px 0px 25px 0px",
                }}
                className="already-memeber-resposive"
              >
                {/* Already a Member? Login here. */}
                Already have a username and password?
              </h1>

              <p className="f18" style={{ color: "white" }}>
                {/* Please enter your username/email and password */}
                Login here.
              </p>
            </div>

            <div className="" style={{ marginTop: "30px" }}>
              <form onSubmit={loginFormik.handleSubmit} autoComplete="off">
                <div className="input_wrap">
                  <label
                    className="label-title"
                    style={{
                      background: "#4E9C4B",
                      color: "white",
                      border: "1px solid black",
                      borderRadius: "20px",
                    }}
                  >
                    Username or Email
                  </label>
                  <input
                    {...loginFormik.getFieldProps("username")}
                    type="text"
                    className="form-control"
                    placeholder="Enter your username or email"
                    // style={{background:'#4E9C4B',border:"1px solid rgba(38, 50, 56, 0.2)"}}
                  />
                  {loginFormik.touched.username &&
                    loginFormik.errors.username && (
                      <p className="text-danger">
                        {loginFormik.errors.username}
                      </p>
                    )}
                </div>

                <div className="input_wrap mt-40">
                  <label
                    className="label-title"
                    style={{
                      background: "#4E9C4B",
                      color: "white",
                      border: "1px solid black",
                      borderRadius: "20px",
                    }}
                  >
                    Password
                  </label>
                  <div  style={{position:'relative'}}>
                  <input
                    {...loginFormik.getFieldProps("password")}
                    // type="password"
                    type={loginPassword ? "text" : "password"}
                    className="form-control pe-5"
                    placeholder="Enter password"
                   
                    // style={{background:'#4E9C4B',border:"1px solid rgba(38, 50, 56, 0.2)"}}
                  />
                  {loginPassword ? (
                    <i
                      className="fa fa-eye position-absolute cursor-pointer "
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                      onClick={() => setLoginPassword(false)}
                      aria-hidden="true"
                    ></i>
                  ) : (
                    <i
                      className="fa fa-eye-slash position-absolute cursor-pointer "
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                      onClick={() => setLoginPassword(true)}
                      aria-hidden="true"
                    ></i>
                  )}
                  </div>
                  {loginFormik.touched.password &&
                    loginFormik.errors.password && (
                      <p className="text-danger">
                        {loginFormik.errors.password}
                      </p>
                    )}
                </div>

                <Link
                  to="/forgot-password"
                  className="mt-4 d-flex"
                  style={{ width: "max-content", color: "white" }}
                >
                  <b>Forgot Password?</b>
                </Link>

                <button
                  type="submit"
                  className="signup-link mt-4 me-3 login_btn mb-4"
                  disabled={postLoading}
                >
                  {postLoading ? (
                    <ThreeDots
                      height="20"
                      width="60"
                      radius="9"
                      color="#4fa94d"
                    />
                  ) : (
                    "Login"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
